import React, { useEffect } from 'react';
import { useEntityPicker } from './useEntityPicker';

/**
 * Generic EntityPickerSelect
 * @param {boolean} allowAll - If true, ID 0 acts as "All". If false, the first option is a "Select" placeholder.
 */
export function EntityPickerSelect({
  config,
  value,
  onChange,
  disabled = false,
  placeholder = "--Select Data--",
  allowAll = true,      // New Toggle
  allLabel = "All",     // Label specifically for the "All" option
  className = "",
}) {
  const { entities, loading, fetchData } = useEntityPicker(config);

  useEffect(() => {
    fetchData();
  }, []);

  const primaryField = config.displayFields.primary;

  // Logic to determine if a real entity is selected
  // If allowAll is false, we strictly check for value.id
  const isSelected = value && value.id !== 0 && value.id !== null && value.id !== undefined;

  // The "empty" value depends on allowAll
  // If allowAll is true, we use "0" as the default
  // If allowAll is false, we use "" so it remains blank
  const defaultValue = allowAll ? "0" : "";

  return (
    <select
      className={`
                w-full border border-gray-300 rounded-md px-3 h-[33px] transition-all cursor-pointer
                focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500
                ${!isSelected ? 'text-gray-400 font-normal' : 'text-gray-700 font-medium border-blue-200 bg-blue-50/10'}
                ${disabled ? 'bg-gray-100 cursor-not-allowed opacity-60' : 'bg-white hover:border-gray-400'}
                ${className}
            `}
      value={value?.id || defaultValue}
      disabled={loading || disabled}
      onChange={(e) => {
        const id = e.target.value;
        if (id === "0" || id === "") {
          onChange(null);
        } else {
          const selectedObj = entities.find(o => o.id.toString() === id.toString());
          onChange(selectedObj);
        }
      }}
    >
      {/* 
        Placeholder Option:
        - If allowAll is true: Acts as the "All" selector (value 0)
        - If allowAll is false: Acts as a "Select..." blank state (value "")
      */}
      <option value={defaultValue}>
        {loading ? 'Loading...' : (allowAll ? allLabel : placeholder)}
      </option>

      {entities.map((item) => (
        <option key={item.id} value={item.id} className="text-gray-800">
          {item[primaryField] || item.name || item.description}
        </option>
      ))}
    </select>
  );
}